/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FixIt API
 * Real-time service marketplace API

## Date & time contract

- **Instants** are ISO-8601 UTC ending in `Z` (`format: date-time`); every `*At` field is an instant.
- **Civil days** are bare `YYYY-MM-DD` (`format: date`) and mean that calendar day in the resource's attribution zone (company/contract zone, default Europe/Prague) - never a UTC or device day.
- **Civil months** are `YYYY-MM`, same anchor.
- **Civil-day range params (`dateFrom`/`dateTo`) are both inclusive** at day granularity - `dateTo=2026-05-31` includes the whole of 31 May.
- **Instant range params** (`from`/`to` taking `Z` instants) are half-open `[from, to)`.
- **DST gaps:** a civil day whose local midnight does not exist in its attribution zone starts at the first existing instant of that day (bounds resolve forward, never into the previous day).
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ApiErrorResponseDto,
  BozpHandoffControllerExchangeV1200,
  BozpHandoffControllerMintV1201,
  ExchangeHandoffDto
} from '.././models';

import { customInstance } from '../../axios-instance';
import type { ErrorType } from '../../axios-instance';




/**
 * @summary Exchange a one-time handoff code for a scoped BOZP access token
 */
export const bozpHandoffControllerExchangeV1 = (
    exchangeHandoffDto: ExchangeHandoffDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BozpHandoffControllerExchangeV1200>(
      {url: `/api/v1/bozp/handoff/exchange`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exchangeHandoffDto, signal
    },
      );
    }
  


export const getBozpHandoffControllerExchangeV1MutationOptions = <TError = ErrorType<ApiErrorResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bozpHandoffControllerExchangeV1>>, TError,{data: ExchangeHandoffDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bozpHandoffControllerExchangeV1>>, TError,{data: ExchangeHandoffDto}, TContext> => {

const mutationKey = ['bozpHandoffControllerExchangeV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bozpHandoffControllerExchangeV1>>, {data: ExchangeHandoffDto}> = (props) => {
          const {data} = props ?? {};

          return  bozpHandoffControllerExchangeV1(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BozpHandoffControllerExchangeV1MutationResult = NonNullable<Awaited<ReturnType<typeof bozpHandoffControllerExchangeV1>>>
    export type BozpHandoffControllerExchangeV1MutationBody = ExchangeHandoffDto
    export type BozpHandoffControllerExchangeV1MutationError = ErrorType<ApiErrorResponseDto>

    /**
 * @summary Exchange a one-time handoff code for a scoped BOZP access token
 */
export const useBozpHandoffControllerExchangeV1 = <TError = ErrorType<ApiErrorResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bozpHandoffControllerExchangeV1>>, TError,{data: ExchangeHandoffDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bozpHandoffControllerExchangeV1>>,
        TError,
        {data: ExchangeHandoffDto},
        TContext
      > => {

      const mutationOptions = getBozpHandoffControllerExchangeV1MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const bozpHandoffControllerMintV1 = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<BozpHandoffControllerMintV1201>(
      {url: `/api/v1/bozp/handoff/mint`, method: 'POST', signal
    },
      );
    }
  


export const getBozpHandoffControllerMintV1MutationOptions = <TError = ErrorType<ApiErrorResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bozpHandoffControllerMintV1>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bozpHandoffControllerMintV1>>, TError,void, TContext> => {

const mutationKey = ['bozpHandoffControllerMintV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bozpHandoffControllerMintV1>>, void> = () => {
          

          return  bozpHandoffControllerMintV1()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BozpHandoffControllerMintV1MutationResult = NonNullable<Awaited<ReturnType<typeof bozpHandoffControllerMintV1>>>
    
    export type BozpHandoffControllerMintV1MutationError = ErrorType<ApiErrorResponseDto>

    export const useBozpHandoffControllerMintV1 = <TError = ErrorType<ApiErrorResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bozpHandoffControllerMintV1>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bozpHandoffControllerMintV1>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getBozpHandoffControllerMintV1MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    